module.exports = __webpack_public_path__ + "static/img/logo.69b351e8.png";